export default __webpack_public_path__ + "static/media/banned.03fcf43b.svg";